import React from "react";
import PropTypes from "prop-types";
import { CardNumberElement } from "react-stripe-elements";
import InputLabel from "components/v3/input-label/InputLabel";
import stripeStyles from "components/v3/payment-form/stripeStyles";
import styles from "./styles.module.scss";

class CardNumber extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: {},
            empty: true
        };

        this._onChange = this._onChange.bind(this);
    }

    _onChange({ error, empty }) {
        this.props.onStripeError("cardNumber", error);

        this.setState({
            error: error || {},
            empty
        });
    }

    render() {
        const { error, empty } = this.state;
        const className = `${ styles.number } ${ empty ? styles.empty : "" } ${ error.message ? styles.error : "" }`;

        return (
            <div className={ className }>
                <div className={ styles.inputLabel }>
                    <InputLabel
                        name="number"
                        label={ error.message || "Card Number" }
                    />
                </div>
                <CardNumberElement
                    style={ stripeStyles }
                    className="stripeInput"
                    placeholder="Credit card number"
                    onChange={ this._onChange }
                />
            </div>
        );
    }
}

CardNumber.propTypes = {
    onStripeError: PropTypes.func.isRequired
};

export default CardNumber;
